import { ProductType, RouteProductType } from 'frontend/enums'
import { Series, SeriesV2 } from 'frontend/types'
import { slugifyLowercase } from './transformers'

const getSlug = ({
  id,
  title,
  mainTitle,
  productType,
  isSingle,
}: {
  id: number
  title?: string
  mainTitle?: string | null
  productType?: string
  isSingle?: boolean
}) =>
  mainTitle && productType !== ProductType.SERIES && !isSingle
    ? `${id}-${slugifyLowercase(mainTitle)}-${slugifyLowercase(title)}`
    : `${id}-${slugifyLowercase(title)}`

const getProductLink = ({
  id,
  title,
  mainTitle,
  productType,
  isSingle,
}: {
  id: number
  title?: string
  mainTitle?: string | null
  productType?: string
  isSingle?: boolean
}) => {
  const productTypeTranslated =
    productType === ProductType.SERIES
      ? RouteProductType.SERIES
      : RouteProductType.PROGRAM

  return `/${productTypeTranslated}/${getSlug({
    id,
    title,
    mainTitle,
    productType,
    isSingle,
  })}`
}

const getPageTitle = (
  program: {
    seoTitle?: string | null
    series?: SeriesV2 | Omit<Series, 'programs'>
    seriesTitle: string | null
    title: string
  },
  isSeriesPage: boolean,
  isSEOTitle: boolean,
): string => {
  let episodeTitle
  let seriesTitle
  let singleProgramTitle

  if (isSEOTitle) {
    episodeTitle = program.seoTitle
    seriesTitle = program.series?.seoTitle
    singleProgramTitle = program.seoTitle
  }

  if (!episodeTitle) {
    episodeTitle = `${program.seriesTitle}: ${program.title}`
  }
  if (!seriesTitle) {
    seriesTitle = program.seriesTitle
  }
  if (!singleProgramTitle) {
    singleProgramTitle = program.title
  }

  if (isSeriesPage) return seriesTitle
  if (program.seriesTitle) return episodeTitle
  return singleProgramTitle
}

const SUPER_SERIES_WITH_REVERSE_ORDER = [187262]

const getProductUrl = (
  productId: number,
  productType: ProductType,
  slug: string,
  series?: Series[],
) => {
  switch (productType) {
    case ProductType.PROGRAM:
      return `/${RouteProductType.PROGRAM}/${slug}`
    case ProductType.SERIES:
      return `/${RouteProductType.SERIES}/${slug}`
    case ProductType.SUPER_SERIES:
      if (series && series?.length < 1) return null

      if (SUPER_SERIES_WITH_REVERSE_ORDER.includes(productId) && series) {
        const lastIndex = series.length - 1
        return series[lastIndex].link
      }

      return series?.[0].link || null
    case ProductType.TRAILER:
      return `/${RouteProductType.TRAILER}/${slug}`
    default:
      return null
  }
}

const productUtils = { getSlug, getPageTitle, getProductUrl, getProductLink }

export default productUtils
